import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    width: 100%;

    @media (min-width: ${wideBreakpoints.mobile}) {
        gap: 18px;
    }
`;

export const Video = styled.video`
    &:focus { outline :none; }
    clip-path: inset(1px 1px);
`;

export const ProgressBarWrapper = styled.div`
    width: 100%;    
    max-width: 260px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        margin-top: 6px;
        max-width: 343px;
    }
`;

export const StatusContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: 32px;
`;

export const StatusItem = styled.div<{ delay: number }>`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background-color: ${COLORS.BgMain};
    display: flex;
    justify-content: center;
    align-items: center;

    &:first-child {
        animation-name: status-animation;
        animation-delay: ${({ delay }) => delay}s;
        animation-duration: .2s;
        z-index: 20;
    }

    &:nth-child(n+3) {
        display: none;
    }

    @keyframes status-animation {
        from { opacity: 1; }
        to   { opacity: 0; }
    }
`;


